import { render, staticRenderFns } from "./EfficiencyOfWorkload.vue?vue&type=template&id=8d8d1d68"
import script from "./EfficiencyOfWorkload.vue?vue&type=script&lang=js"
export * from "./EfficiencyOfWorkload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d8d1d68')) {
      api.createRecord('8d8d1d68', component.options)
    } else {
      api.reload('8d8d1d68', component.options)
    }
    module.hot.accept("./EfficiencyOfWorkload.vue?vue&type=template&id=8d8d1d68", function () {
      api.rerender('8d8d1d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/EfficiencyOfWorkload.vue"
export default component.exports